<template>
    <div id="app">
        <notifications group="info" position="top right" />
        <horizontal></horizontal>

        <div class="container-fluid">
            <div v-if="$route.fullPath.includes('recover_password')">
                <main class="content-login mt-5 row justify-content-center">
                    <recuperar-password/>
                </main>
            </div>
            <div class="row" v-if="!$store.state.user && !$route.fullPath.includes('recover_password')">
                <main class="col-md-9 ms-sm-auto col-lg-9 px-md-4">
                    <login></login>
                </main>
            </div>
            <div class="row" v-if="$store.state.user && !$route.fullPath.includes('recover_password')">
                <sidebar v-if="$route.name!='Login'"></sidebar>

                <main class="col-md-9 ms-sm-auto col-lg-9 px-md-4">
                    <router-view :key="$route.fullPath"></router-view>
                </main>
            </div>
        </div>
    </div>
</template>

<script>

// import MenuBar from '@/components/Menu.vue'
import Horizontal from '@/components/Horizontal.vue'
import Sidebar from '@/components/Sidebar.vue'
import Login from '@/views/Login.vue'
import RecuperarPassword from '@/views/RecuperarPassword'

export default {
  name: 'Menu',
  props: [],
  components: { Horizontal, Sidebar, Login, RecuperarPassword },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // debugger
  }
}
</script>
